/* eslint-disable react/prop-types */ // TODO: add props
import PT from 'prop-types';
import cx from 'classnames';
import { Link } from 'react-router-dom';
import style from './ProgressLink.scss';

const getProgressStyle = (percentage) => {
  if (percentage === 100) {
    return style.complete;
  } else if (percentage === 0) {
    return style.zero;
  } else if (percentage <= 20) {
    return style['very-low'];
  } else if (percentage > 20 && percentage <= 40) {
    return style.low;
  } else if (percentage > 40 && percentage <= 60) {
    return style.med;
  } else if (percentage > 60 && percentage <= 80) {
    return style.high;
  } else if (percentage > 80) {
    return style['very-high'];
  }
  return '';
};

const ProgressLinkLoader = () => <div className={style.loading} />;

const HorizontalProgressBar = ({ value, max, isLoading, className }) => {
  let barWidthPercentage = max ? (100 * value) / max : 0;
  barWidthPercentage = isLoading ? 0 : barWidthPercentage;

  return (
    <div className={cx(style.progressBarWrapper, className)}>
      {isLoading ? (
        <ProgressLinkLoader />
      ) : (
        <div
          className={cx(getProgressStyle(barWidthPercentage))}
          style={{ width: `${barWidthPercentage}%` }}
        />
      )}
    </div>
  );
};

const ProgressLink = ({
  value,
  max,
  isLoading,
  children,
  button,
  hideProgressBar,
  anchor,
  className,
  to,
  ...linkProps
}) => {
  return anchor ? (
    <a
      href={to}
      className={cx(style.progressLink, className, {
        [style.buttonize]: button,
      })}
      {...linkProps}
    >
      <span
        className={cx({ [style.text]: !hideProgressBar })}
        data-test="progress-link"
      >
        {children}
      </span>
      {!hideProgressBar && (
        <HorizontalProgressBar max={max} value={value} isLoading={isLoading} />
      )}
    </a>
  ) : (
    <Link
      to={to}
      className={cx(style.progressLink, className, {
        [style.buttonize]: button,
      })}
      {...linkProps}
    >
      <span
        className={cx({ [style.text]: !hideProgressBar })}
        data-test="progress-link"
      >
        {children}
      </span>
      {!hideProgressBar && (
        <HorizontalProgressBar max={max} value={value} isLoading={isLoading} />
      )}
    </Link>
  );
};

ProgressLink.propTypes = {
  value: PT.number,
  max: PT.number,
  isLoading: PT.bool,
  className: PT.string,
  text: PT.string,
  button: PT.bool,
  to: PT.string,
  anchor: PT.bool,
  pillValue: PT.number,
  pillMax: PT.number,
};

export default ProgressLink;
